import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=b1f68078&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=b1f68078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f68078",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1f68078')) {
      api.createRecord('b1f68078', component.options)
    } else {
      api.reload('b1f68078', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=b1f68078&scoped=true&", function () {
      api.rerender('b1f68078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Gc08WG0ACP1A/JS/comp/DocBox.vue"
export default component.exports